var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ams-table',{attrs:{"heading":_vm.heading,"ams_api_path":_vm.ams_api_path,"ams_type":_vm.ams_type,"ams_fields":_vm.ams_fields}})}
var staticRenderFns = []

export { render, staticRenderFns }